import React from 'react';
import {Button, Select, Tag, Icon, Popover, Input, message} from 'antd';
import {connect} from 'react-redux';
import AjaxAction from '../../actions/AjaxAction.js';
import ajaxUtil from '../../util/ajax';
import './index.scss';

const {ajaxv2, DOMAIN_CURRENT} = ajaxUtil;
const { CheckableTag } = Tag;

class DataTagSelect extends React.Component {
  state = {
    tagList:null,
    isClickAdd:false,
    visible:false,
    search:""
  };

  componentDidMount() {
    let {category, value} = this.props;
  }

  fetchTagList = ()=>{
    let {tagList} = this.state;
    if(!tagList) {
      let {tagType, category} = this.props;

      ajaxv2({
        url:DOMAIN_CURRENT + '/api/v2/tags/detail/byuser/catetory/'+category.id+'/list'
      }).then(res=>{
        if(res && res instanceof Array) {
          this.setState({
            tagList:res
          })
        }
      });
    }
  }

  // 一个删除标签，搞得好复杂 - 2019-10-16
  canClosable = (tag, category)=>{
    let {myInfo} = this.props;
    // 如果是具备相关权限的人，什么事都可以干
    if(!window.actionFor('tag-edit', 'boolean')) {
      return true;
    }

    if(tag && tag.created_by != myInfo.id) {
      return false;
    }

    return true;
  }

  renderChildren = ()=>{
    let {value, maxTag, category} = this.props;

    if(typeof value == 'string') {
      value = value.split(',');
    }


    return (value || []).map(it=>{
      return <Tag key={it.id} closable={this.canClosable(it, category)} onClose={()=>{
        this.onDeleteTag(it);
      }} onClick={
        category.is_radio * 1 || true ? ()=>{this.onVisibleChange(true)} : null
      }>{it.name}</Tag>;
    })
  }

  renderTag = ()=>{
    let {value, maxTag, category} = this.props;
    let {tagList, search} = this.state;
    let max = 20;
    // 如果标签超过三十个，则提供搜索功能
    if(tagList && tagList.length > max) {
      let result = [];
      for(var i=0;i<tagList.length;i++) {
        let item = tagList[i];
        if(!!(value || []).filter(t=>t.id==item.id).length) {

        }else {
          if(search) {
            if(item.name.indexOf(search) > -1) {
              result.push(item);
            }
          }else {
            result.push(item);
          }
        }

        if(result.length >= max) {
          break;
        }
      }

      return <React.Fragment>
        <div>
          <Input size="small" placeholder="输入标签名称，快捷搜索" onChange={(e)=>{
            this.setState({
              search:e.target.value
            })
          }} />
        </div>
        {value && value.length ? <React.Fragment>
          <div>
            <h6 style={{ marginRight: 8, display: 'inline' }}>已选标签：</h6>
            {value.map(tag => (
              <CheckableTag
                key={tag.id}
                checked={true}
                onChange={checked => this.handleChange(tag, checked)}
              >
                {tag.name}
              </CheckableTag>
            ))}
          </div>
        </React.Fragment> : null}
        <div>
          <h6 style={{ marginRight: 8, display: 'inline' }}>可选标签：</h6>
          {result.map(it=>{
            return <CheckableTag
              key={it.id}
              checked={!!(value || []).filter(t=>t.id==it.id).length ? true : false}
              onChange={checked => this.handleChange(it, checked)}
            >
              {it.name}
            </CheckableTag>;
          })}
        </div>
      </React.Fragment>;
    }else {
      return (tagList || []).map(it=>{
        return <CheckableTag
          key={it.id}
          checked={!!(value || []).filter(t=>t.id==it.id).length ? true : false}
          onChange={checked => this.handleChange(it, checked)}
        >
          {it.name}
        </CheckableTag>;
      });
    }
  }

  onDeleteTag = (tag)=>{
    this.handleChange(tag, false);
  }

  formatAllTag = (tag)=>{
    let {value, category} = this.props;

    value = value.map(it=>{
      // delete it.action;
      if(tag.id == it.id && tag.action == 'del') {
        return null;
      }

      return it;
    }).filter(Boolean);
    if(category.is_radio * 1) {
      if(tag && tag.action == 'add') {
        delete tag.action;
        value = [tag];
      }
    }else {
      if(tag && tag.action == 'add') {
        delete tag.action;
        value.push(tag);
      }
    }
    return value;
  }

  handleChange = (tag, checked)=>{
    let {category, value} = this.props;
    let {tagList} = this.state;

    if(checked) {
      tag.action = 'add';
    }else {
      tag.action = 'del';
      if(typeof value == 'string') {
        value = value.split(',');
      }
      if(category && !category.is_radio * 1) {
        if(value && value.length <= 1) {
          message.error('至少保留一个标签');
          return;
        }
      }
    }

    if(this.props.onItemChange) {
      this.props.onItemChange(tag, category);
    }

    if(this.props.onChange) {
      this.props.onChange(this.formatAllTag(tag), category);
    }
  }

  shouldShowAdd = ()=>{
    let {value, maxTag, category} = this.props;

    if(typeof value == 'string') {
      value = value.split(',');
    }

    if(category) {
      if(category.is_radio * 1) {
        if(value && value.length) {
          return false;
        }else {
          return true;
        }
      }else {
        return true;
      }
    }

    return false;
  }

  onVisibleChange = (e)=>{
    this.setState({
      visible:e
    });

    if(e) {
      this.fetchTagList();
    }
  }

  handleInputConfirm = ()=>{
    let {inputValue, tagList} = this.state;
    let {category, onAddTag} = this.props;

    if(inputValue) {
      if(onAddTag) {
        let promise = onAddTag((inputValue || "").replace(/[\s，,]/ig, ''), category);
        if(promise && promise.then) {
          promise.then((res)=>{
            if(res && res.id) {
              tagList.push(res);
              this.setState({
                tagList
              });
            }
          });
        }
      }
    }

    this.setState({
      inputValue:"",
      isClickAdd:false
    });
  }

  render() {
    let {value, maxTag, category, showAdd} = this.props;
    let {isClickAdd, inputValue} = this.state;

    if(typeof value == 'string') {
      value = value.split(',');
    }

    return (
      <div className="dp-f datatag-select">
        <div className="datatag-select-label">{category && category.name}</div>
        <div className="datatag-select-content">
          {this.renderChildren()}
          <div className="datatag-select-item">
            <Popover
              overlayClassName="datatag-popover"
              title="标签" visible={this.state.visible}
              onVisibleChange={this.onVisibleChange}
              placement="bottom"
              trigger="click"
              content={
              <div className="datatag-select-popover">
                {this.renderTag()}
                {showAdd ? <React.Fragment>
                  {isClickAdd && (
                    <Input
                      ref={input=>this.input = input}
                      type="text"
                      size="small"
                      style={{ width: 78 }}
                      value={inputValue}
                      onChange={(e)=>{
                        this.setState({
                          inputValue:e.target.value
                        });
                      }}
                      onBlur={this.handleInputConfirm}
                      onPressEnter={this.handleInputConfirm}
                    />
                  )}
                  {!isClickAdd && (
                    <Tag onClick={()=>{
                      this.setState({
                        isClickAdd:true
                      }, ()=>{
                        this.input.focus();
                      })
                    }} style={{ background: '#fff', borderStyle: 'dashed' }}>
                      <Icon type="plus" /> 添加标签
                    </Tag>
                  )}
                </React.Fragment> : null}
              </div>
            }
            >
              {this.shouldShowAdd() ? <a  className="datatag-select-item-add"><Icon type="plus" style={{marginRight:5}} />添加</a> : <a>{' '}</a>}
            </Popover>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(DataTagSelect);



// WEBPACK FOOTER //
// ./src/components/Select/DataTag.js